<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">撥入對象-單位服務人員</h3>
        </div>
        <div class="modal-body">
            <section class="search pb-0 mb-4">
                <div class="row">
                    <div class="col-12">
                        <form class="form">
                            <div class="input-group input-lg">
                            <div class="input">
                                <input
                                type="text"
                                name="keyowrd"
                                id="keyowrd"
                                class="form-control"
                                v-model="keyowrd"
                                placeholder="輸入服務人員姓名或收費代號進行搜尋...">
                            </div>
                            <button
                            class="btn btn-primary btn-icon"
                            type="submit"
                            @click.prevent="doSearch()">
                                <i class="icon-search i-24"></i>
                            </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

            <data-table
            :multiple="false"
            :prefix="'dial-in-table'"
            @update="updateSelection"
            :options="tableOption" 
            :table-data="tableData"
            :currentPage="currentPage"
            :totalpages="totalpages"
            :scroll-data-loading="scrollDataLoading"
            :remote-data-msg="remoteDataMsg"/>
            
            <div class="row">
                <div class="col-12 text-right">
                    <a @click="$emit('close')" class="btn btn-default">取消</a>
                    <a @click="$emit('submit', selection)" class="btn btn-primary">加入</a>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import DataTable from "@/components/DataTable/DataTableScroll";

export default {
    name: 'DialInPersonModal',
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            remoteDataMsg: "資料讀取中，請稍候...",
            keyowrd: '',
            currentPage: 0,
            totalpages: 1,
            selection: [],
            scrollDataLoading: false,
            tableOption: {
                checkAll: true,
                scrollHeight: 0,
                isScrollLoading: true,
                checkBoxHasUser: false,
                columns: [
                    {
                        width: 100,
                        name: "name",
                        label: "姓名",
                        sorting: true
                    },
                    {
                        name: "no",
                        label: "收費代號",
                        sorting: true
                    },
                    {
                        width: 120,
                        name: "numbers",
                        label: "要保人數",
                        sorting: true
                    }
                ],
                sorting: (order_by) => {
                    this.tableData = []
                    if(this.order.order_by == order_by){
                        this.order.order_asc = !this.order.order_asc
                    }else{
                        this.order.order_asc = true
                    }
                    this.order.order_by = order_by
                    this.getCustomersAndSetup(this.$store.state.userInfo.id, this.keyowrd)
                },
                scrollLoadingAPI: () => {
                    this.scrollDataLoading = true
                    this.currentPage = this.currentPage + 1
                    console.log("load more", 'page:'+　this.currentPa)
                    this.getCustomersPage(this.$store.state.userInfo.id, this.keyowrd)
                }
            },
            tableData: [
                {
                    id: 1,
                    name: '尚華強',
                    no: 'FN59999',
                    numbers: 456
                },
                {
                    id: 2,
                    name: '吳和龍',
                    no: 'FN52099',
                    numbers: 433
                },
                {
                    id: 3,
                    name: '吳孟達',
                    no: 'FN52501',
                    numbers: 211
                }
            ]
        }
    },
    components: {
        DataTable
    },
    methods: {
        updateSelection (val) {
            this.selection = val
        },
    }
}
</script>
